import LWTooltip, { STooltip } from './LWTooltip';

export { LWTooltip, STooltip };
export default LWTooltip;
